export default {
      id: "arrow-single-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#arrow-single",
      toString: function () {
        return this.url;
      }
    }